/* eslint-disable */
import { phoneTypes } from '@ringcentral-integration/commons/enums/phoneTypes';
export default {
  [phoneTypes.business]: 'Telefon (geschäftlich)',
  [phoneTypes.extension]: 'Nebenstellennummer',
  [phoneTypes.home]: 'Privatnummer',
  [phoneTypes.mobile]: 'Mobiltelefon',
  [phoneTypes.phone]: 'Telefon',
  [phoneTypes.unknown]: 'Unbekannter Telefontyp',
  [phoneTypes.company]: 'Unternehmensnummer',
  [phoneTypes.direct]: 'Durchwahlnummer',
  [phoneTypes.contact]: 'Kontakttelefon',
  [phoneTypes.fax]: 'Fax',
  [phoneTypes.other]: 'Sonstiges',
};

// @key: @#@"[phoneTypes.business]"@#@ @source: @#@"Business Phone"@#@
// @key: @#@"[phoneTypes.extension]"@#@ @source: @#@"Extension Number"@#@
// @key: @#@"[phoneTypes.home]"@#@ @source: @#@"Home Number"@#@
// @key: @#@"[phoneTypes.mobile]"@#@ @source: @#@"Mobile Phone"@#@
// @key: @#@"[phoneTypes.phone]"@#@ @source: @#@"Phone"@#@
// @key: @#@"[phoneTypes.unknown]"@#@ @source: @#@"Unknown Phone Type"@#@
// @key: @#@"[phoneTypes.company]"@#@ @source: @#@"Company Number"@#@
// @key: @#@"[phoneTypes.direct]"@#@ @source: @#@"Direct Number"@#@
// @key: @#@"[phoneTypes.contact]"@#@ @source: @#@"Contact Phone"@#@
// @key: @#@"[phoneTypes.fax]"@#@ @source: @#@"Fax"@#@
// @key: @#@"[phoneTypes.other]"@#@ @source: @#@"Other"@#@
